import type { ComputedRef } from 'vue'

import { computed } from 'vue'
import { actionTypes } from '@/store/modules/page-message'
import store from '@/store'
import { UnderTitleMessageType } from '@/enums/messageEnum'

export interface UsePageMessage {
  pageMessages: ComputedRef<string[]>
  messageType: ComputedRef<UnderTitleMessageType>
  setPageMessages: (messages: string[], messageType?: UnderTitleMessageType) => void
  addPageMessage: (message: string, messageType?: UnderTitleMessageType) => void
  deleteOnePageMessage: (message: string, messageType?: UnderTitleMessageType) => void
  clearPageMessages: () => void
  ballonMessageLastType: ComputedRef<string>
  setBallonMessageLastType: (type: string) => void
}

const usePageMessage = (): UsePageMessage => {
  const _state = store.state.pageMessage

  return {
    pageMessages: computed<string[]>(() => _state.pageMessages),
    messageType: computed<UnderTitleMessageType>(() => _state.messageType),

    setPageMessages: (
      messages: string[],
      messageType: UnderTitleMessageType = UnderTitleMessageType.ERROR
    ): void => {
      store.dispatch(actionTypes.SET_PAGE_MESSAGES, { messages, messageType })
    },

    addPageMessage: (
      message: string,
      messageType: UnderTitleMessageType = UnderTitleMessageType.ERROR
    ): void => {
      store.dispatch(actionTypes.ADD_PAGE_MESSAGE, { message, messageType })
    },

    deleteOnePageMessage: (
      message: string,
      messageType: UnderTitleMessageType = UnderTitleMessageType.ERROR
    ): void => {
      store.dispatch(actionTypes.DELETE_ONE_PAGE_MESSAGE, { message, messageType })
    },

    clearPageMessages: (): void => {
      store.dispatch(actionTypes.CLEAR_PAGE_MESSAGE)
    },

    ballonMessageLastType: computed<string>(() => _state.ballonMessageLastType),

    setBallonMessageLastType: (type: string): void => {
      store.dispatch(actionTypes.SET_BALLON_MESSAGE_LAST_TYPE, type)
    },
  }
}

export default usePageMessage
